import dayjs from 'dayjs'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import relativeTime from 'dayjs/plugin/relativeTime'
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);
dayjs.extend(localizedFormat)
dayjs.extend(relativeTime)

import urls from '../urls'


export default {
    data() {
        return {
            isDestroyed: false,
            compLoader: null,
            // pager: {
            //     pageCount: 1
            // },
            // page: 1,
            SEARCH_DEBOUNCE_MS: 1000*1.5,
            dateFormatter: () => {
            },
            defaultErrorMessage: 'Please fix the following errors:',
            defaultGenericErrorMessage: 'Please fix these errors:',


            CLASSES: {
                MODAL_HEADER: "modal-header",
                TEXT_MODAL_VIEW: "alert alert-info",
                TEXT_MODAL_VIEW_WARN: "alert alert-warning",
                FORM_INPUT: "form-control",
                TBL_BTN: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm",
            },

            select_placeholder: 'Select One',

            BS_SLUGS: {
                "pre_marketing": "pre_marketing",
                "initial_contact": "initial_contact",
                "teaser_sent": "teaser_sent",
                "nda_sent": "nda_sent",
                "nda_signed": "nda_signed",
                "cim_sent": "cim_sent",
                "bid_received": "bid_received",
                "management_presentation": "management_presentation",
                "final_bids": "final_bids",
                "due_diligence": "due_diligence",
                "head_of_terms": "head_of_terms",
                "negotiating_spa": "negotiating_spa",
                "declined": "declined",
                "not_to_be_contacted": "not_to_be_contacted"
            },

            DROPZONE_HEADERS: {
                // non-api
                // 'X-CSRFToken': window.KTCookie.get('csrftoken'),
                // api'
                'Authorization': window.API_AUTH_TOKEN,
                'Cache-Control': null,
                'X-Requested-With': null,
            },
        }
    },
    watch: {
        page: function (newVal, oldVal) {
            // console.log(newVal)
            // this.$store.page = newVal
        },
        pager: function (newVal, oldVal) {
            // this.$store.pager = newVal
        }
    },
    created() {
    },
    mounted() {
        // this.endCompLoading()
    },
    destroyed() {
        this.isDestroyed = true
    },
    computed: {
        // isProjectModule(){
        //     return this.$route.params.module == 'project'
        // },
        // isCrmModule(){
        //     return this.$route.params.module == 'crm'
        // },
    },
    methods: {
        initPage() {
            // https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams
            // const has_ = new URL(location.href).searchParams.get('page')
            const has_ = this.$route.query.page

            // console.log('initpage', has_)
            this.setPage(has_ ? parseInt(has_) : 1)
        },
        setPage(page) {
            // console.log('setpage', page)
            this.page = page ?? this.page
        },
        setPageQueryParam(page, args=[]){
            // otherwise shows a duplicate navigation error
            if(this.$route.query.page == page) return

            // WARN: router param replace triggers router.beforeEach
            this.$router.replace({query: {page}})
        },
        searchParamsGen(obj={}, args={}){
            const usp = new URLSearchParams()
            for (const k in obj){
                const val = obj[k]
                if(Array.isArray(val)){
                    //k=1&k=2
                    for(const k_ in val){
                        usp.append(k, val[k_])
                    }
                }else{
                    if(val !== null){
                        usp.append(k, val)
                    }
                }
            }
            return usp.toString()
        },
        hasPermission(key_) {
            return this.$ltypes.permissions.includes(key_)
        },
        defaultYear() {
            return dayjs().format('YYYY')
        },
        defaultMonth() {
            return dayjs().format('MM')
        },
        ucfirst(name) {
            if (!name) return name;

            return name.charAt(0).toUpperCase() + name.slice(1)
        },

        todayMixin(format = 'DD/MM/YYYY') {
            return dayjs().format(format)
        },
        momentMixin(datetime, format = 'DD/MM/YYYY', args = {ago: false, object: false}) {
            if (!datetime) return datetime;
            if (args && args.object) return format ? dayjs(datetime, format) : dayjs(datetime) //dayjs obj from string
            if (args && args.ago) return dayjs(datetime).fromNow()
            return dayjs(datetime).format(format)
        },

        download(path) {
            return path
        },
        static(path) {
            return `/vstatic/${path}`
        },
        media(path) {
            return `${API_HOST}/media/${path}`
        },
        metrosvg(path){
            //icons/Communication/Dial-numbers.svg
            return this.static(`metronic/assets/media/svg/${path}`)
        },

        startCompLoading() {
            this.unblockUI()
            return this.blockUI()
        },
        endCompLoading() {
            return this.unblockUI()
        },

        unblockUI() {
            $.unblockUI({ fadeOut: 100 });
            return

            if(window.blockUI.isBlocked()){
                window.blockUI.release()
            }
        },
        blockUI(params) {
            // $.blockUI({ css: { backgroundColor: '#f00', color: '#fff' } });
            $.blockUI({
              message: '<div class="spinner-border text-primary" role="status"><span class="sr-only">Loading...</span></div>',
              css: {
                border: 'none',
                backgroundColor: 'transparent'
              },
              overlayCSS: {
                backgroundColor: '#000',
                opacity: 0.2,
                cursor: 'wait'
              }
            });
            return

            const default_ = {
                focusInput: false,
                bindEvents: false,
                centerX: false,
                centerY: false,
                unblock: false,
                timeout: 0,
                overlayColor: '#000000',
                opacity: 0.5,
            }
            const options = {
                ...default_,
                ...params,
            }
            if (options.unblock) return this.unblockUI();

            // KTApp.blockPage({
            //     overlayColor: options.overlayColor,
            //     opacity: options.opacity,
            //     state: 'primary',
            //     message: 'Please wait...',
            // });
            window.blockUI.block()

            if (!options.timeout) return;

            setTimeout(() => this.unblockUI(), options.timeout);
        },

        mixinPagination(data, set_pager = true) {
            const pager_ = {
                current_page: data.currentPage,
                per_page: data.perPage,
                total: data.total,
                pageCount: data.pageCount,
            };

            if (set_pager) {
                this.pager = {...pager_}
            }

            return pager_
            // console.log(this.pager)
        },

        urlb(path, ...params) {
            console.log(path, params, params.length)
            let pathf = path

            // append get params
            if (params.length > 0) {
                pathf += '?'
                for (let i = 0; i < params.length; i++) {
                    pathf += `${params[i][0]}=${params[i][1]}&`
                }
            }
            console.log(pathf)

            return pathf;
        },

        genUrl(name, pk = null, key = null, ...params) {
            const url_ = urls[name]
            if (!url_) throw new Error(`URL does not exist in list: name:${name}, pk:${pk}, key:${key} params: ${params.toString()}`);

            let key_ = key;
            if (!key) {
                key_ = pk ? 'post' : 'get'
            }

            const full_ = url_[key_]
            if (!full_) throw new Error(`URL does not exist in list: name:${name}, pk:${pk}, key:${key} params: ${params.toString()}`);
            // console.log(url_[key_].replace('',''), key_, key, key_, name)
            const url = pk ? full_.replace(':pk:', pk) : full_;
            // console.log(url)
            return url;
        },
        getUrl(name, key, pk=null, params) {
            console.warn("DEPRECATED. Please use genUrl(...) instead")
            return this.genUrl(name, pk, key, params)

            const url_ = urls[name]
            if (!url_) throw new Error(`URL does not exist in list: name:${name}, pk:${pk}, key:${key} params: ${params.toString()}`);

            const key_ = url_[key]
            if (!key_) throw new Error(`URL does not exist in list: name:${name}, pk:${pk}, key:${key} params: ${params.toString()}`);

            const url = pk ? key_.replace(':pk:', pk) : key_;

            return url;
        },

        yesNo(bool_) {
            return bool_ ? this.$t('yes') : this.$t('no')
        },
        /*
        handler = [()=>{}, ()=>{}]
        0 is success handler, 1 is cancel
        * */
        confirmationDialog(handler, title = 'Confirm Delete', text = 'Are you sure you wish to delete this record?') {
            window.Swal.fire({
                title,
                text,
                // icon: "warning",
                icon: null,
                showCancelButton: true,
                confirmButtonText: "Yes",
                confirmButtonColor: '#1b84ff',
                cancelButtonText: "Cancel",
            })
                .then(function (result) {
                    if (result.value) {
                        handler()
                    }
                });
        },
        confirmationWithInputDialog(handler, title = 'Confirm Delete', text = ''){
            let confirm = window.Swal.fire({
              title,
              input: "text",
              icon: "warning",
              inputAttributes: {
                autocapitalize: "off"
              },
              showCancelButton: true,
              confirmButtonText: "Confirm",
              confirmButtonColor: '#1b84ff',
              showLoaderOnConfirm: true,
              inputValidator: (value) => {
                if (!value || value !== 'DELETE') {
                  return 'You must type DELETE to confirm.';
                }
                return null;
              }
            }).then((result) => {
              if (result.isConfirmed && result.value == 'DELETE') {
                handler()
              }else if(result.dismiss){
                
                  confirm
                    window.Swal.fire({
                      title: "Cancelled",
                      text: "Your data is safe :)",
                      icon: "error"
                    });
              }
            });
        },

        toastService(type = 'success', title = '', message = '') {
            //metronic includes toastr library
            this.$toastr.options = {
                "closeButton": true,
                "debug": false,
                "newestOnTop": true,
                "progressBar": true,
                "positionClass": "toastr-top-right",
                "preventDuplicates": false,
                "onclick": null,
                "showDuration": "300",
                "hideDuration": "1000",
                "timeOut": "5000",
                "extendedTimeOut": "1000",
                "showEasing": "swing",
                "hideEasing": "linear",
                "showMethod": "fadeIn",
                "hideMethod": "fadeOut"
            };

            this.$toastr[type](message, title);
        },
        toastSuccess(title = 'Success!', message = 'Action performed successfully.') {
            this.toastService('success', title, message)
        },
        toastError(title = 'Error!', message = 'Something went wrong.') {
            this.toastService('error', title, message)
        },
        toastWarning(title = 'Warning!', message = 'Something went wrong.') {
            this.toastService('warning', title, message)
        },
        toastLaravelError(errobj) {
            Object.entries(errobj).forEach(([key, value]) => {
                value.forEach(ele => {
                    this.toastService('error', key, ele)
                })
            });
        },
        toastLaraValidation(errobj) {
            console.info('toastLaraValidation', errobj)
            
            if (errobj.response?.data) {
                const errobj_ = errobj.response.data

                if (errobj_.errors) return this.toastLaravelError(errobj_.errors)

                if (errobj_.message) {
                    return this.toastService('error', 'Failed!', errobj_.message)
                }
            }

            this.toastService('error', 'Error', errobj.message)

        },
        extractErrors(response) {
            if (!response.data || typeof response.data !== 'object') {
                return {error: Form.errorMessage}
            }

            if (response.data.errors) {
                return {...response.data.errors}
            }

            if (response.data.message) {
                return {error: response.data.message}
            }

            return {...response.data}
        },

        djOrder(key, order = 'asc') {
            if (!key) return undefined

            return `${order == 'asc' ? '' : '-'}${key}`
        },

        //select2 template
        userTemplate(item) {
            return `<div>x${_.get(item.raw_.profile, 'first_name')} ${_.get(item.raw_.profile, 'last_name')}</div><small>${item.text}</small>`
        },
        userSelectionTemplate(item) {
            return `x${_.get(item.raw_.profile, 'first_name')} ${_.get(item.raw_.profile, 'last_name')}`
        },

        numberFormat(number) {
            if (!number) return number

            return `£${Intl.NumberFormat().format(number)}`
        },
        numberWithoutCurrencySignFormat(number) {
            if (!number) return

            return `${Intl.NumberFormat().format(number)}`
        },
        decimalNumberFormat(decimal_, digit=2){
            if(!decimal_) return
            return decimal_.toFixed(digit)
        },

        setTitle(title) {
            // this.$set(this.$route.meta, 'title', title)
            this.$route.meta.title = title
            document.title = title
        },

        iteratePaginatorRequest(method, data, page, iteration) {
              if(this.isDestroyed){
                  console.warn('ITERATOR_ABORTED_COMPONENT_DESTROYED')
                return 3
              }

            if (iteration > 50) {
                throw Error("Too many iterations on paginator request")
            }
            if (data.currentPage >= data.pageCount) return 2

            method(page + 1, iteration + 1)
        },

        to_String(input){
            return new String(input)
        }
    }
}
